var map = {
	"./pr-1.png": "ee41",
	"./pr-2.png": "5ee5",
	"./pr-3.png": "3065",
	"./pr-4.png": "dd26",
	"./pr-5.png": "8077",
	"./pr-6.png": "434c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1a7";